import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from './../router'

import {
  VueAxios
} from './axios'
import notification from 'ant-design-vue/es/notification'
import {
  ACCESS_TOKEN
} from '@/store/mutation-types'

import { isWeiXin, showMsg } from '@/utils/util'
// 创建 axios 实例
const service = axios.create({
  baseURL: '/api', // api base_url
  timeout: 60000 // 请求超时时间
})

let hasToken = true

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message:  data.message,
        //description: data.message
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        //message: 'Unauthorized',
        message: 'Authorization verification failed'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }

    if (error.response.status === 500) {
      notification.error({
        message: data.message
        // description: data.message
      })
    }
  }else{
    if (error.code === "ECONNABORTED") {
      notification.error({
        message: '网络出现异常',
        //description: "请求超时"
      })
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  // 去除请求参数中的空格
  // if (config.params !== undefined && config.params.constructor === Object){
  //   for (var key in config.params) {
  //     config.params[key] = config.params[key].toString().trim()
  //   }
  // }
  // if (config.data !== undefined && config.data.constructor === Object){
  //   for (var key in config.data) {
  //     // config.data[key] = config.data[key].toString().replace(/(^\s*)|(\s*$)/g, "")
  //     config.data[key] = config.data[key].toString().trim()
  //   }
  // }
  const token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    // config.headers['Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    // console.log("=========zzshr=============")
    // console.log(token)
    config.headers['accessToken'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
  // Vue.ls.set(ACCESS_TOKEN, response.headers.accesstoken, 30 * 24 * 60 * 60 * 1000)
  if (response.data.code !== '0') {
    if (response.data.code === '2001') {
      router.push({name: "login"})
      return
    } else {
      // const token = response.headers.accesstoken
      // if (token) {
      //   Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
      // }
    }
    if (!isWeiXin()){
      notification.error({
        message: response.data.message,
        // description: response.data.message
      }) 
    }else{
      showMsg(response.data.message)
    }
    return response.data
  } else {
    if (response.data.message){
      notification.success({
        message: response.data.message,
        // description: response.data.message
      })
    }
  
    // Vue.$message.success(response.data.message) 
    // const token = response.headers.accesstoken
    // if (token) {
    //   Vue.ls.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
    // }
  }
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
